/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ScreenXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABJ0lEQVR4nN2UwUrDQBCGe/IB7EP0oIUighfx4NXOP5vDZsaCB5/G+FoW30RtG/ARtDJrU7TJ1jRJoTgwZGEy/7ezOzu93r8x7/0RnDwSyxucLps4OXmF08y0SgALNBVG2bMSYEXfVegzVklVBZUiY3d7CegFWPO1AMuCeTIC/IBYPqry6gOS9MzizJOhCcPJnEhPQg70PJZXG0Asi0LQvsXagD+ragzACnKTpKfrf+EHYJ1ty9kJANZ8E/BXO9cHsOZ2HJtHFNbhTtreQaLXhWC44O8OCkAgvWpfAdJ7E/q1W9bcwCFWF9DwoS0j/rLXUUGsD5Fhp1mbSmjbsDsII9Z3870BEOuQLsy5u34B8N4fdyZMTp/jr1ymrQFgmca7Rp86qeKg7QsEfBhGOROMJgAAAABJRU5ErkJggg==)
 */
export const ScreenXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm6.3.3a1 1 0 0 1 1.4 0L12 7.58l2.3-2.3a1 1 0 1 1 1.4 1.42L13.42 9l2.3 2.3a1 1 0 0 1-1.42 1.4L12 10.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L10.58 9l-2.3-2.3a1 1 0 0 1 0-1.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 19.5c0 .28.22.5.5.5H15a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h1.5a.5.5 0 0 0 .5-.5v-2c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v2Z"
        className={colorClass}
      />
    </svg>
  );
};
